export const keys = {
  all: ["wave-sync"] as const,
  getUnlik: () => [...keys.all, "unlink"] as const,
  getStatus: () => [...keys.all, "status"] as const,
  getDevice: () => [...keys.all, "device"] as const,
  getVideo: (deviceId: string, timestamp: string) =>
    [...keys.all, "video", deviceId, timestamp] as const
};
